export const DESC_DEFAULT_LENGTH = 100;

// 'SpeakClub' is the internal key for the ELA Club Stripe account and Bulk Message class; show the product name.
export const accountLabel = (account) => (account === 'SpeakClub' ? 'ELA Club' : account);
